import {action, makeObservable, observable} from 'mobx';
import FileData from '../../utils/file/FileData';

export interface IAttachmentProgress {
  isUpload?: boolean;
  isDone?: boolean;
  inProgress?: boolean;
  progress: number; // Float between 0 and 1.
  progressPercent: number;
  error?: string | null;

  channelID?: Uint8Array | null;
  fileName?: string | null;
  scope?: string | null;

  abortController?: AbortController;
  dataFile?: FileData | null;
  isCanceled?: boolean;
  cancelable?: boolean;
}

export class AttachmentProgress implements IAttachmentProgress {
  constructor(props?: IAttachmentProgress) {
    makeObservable(this);
    this.fill(props);
  }

  @observable isUpload: boolean = false;
  @observable isDone: boolean = false;
  @observable inProgress: boolean = false;
  @observable progress: number = 0;
  @observable progressPercent: number = 0;
  @observable error?: string | null;

  @observable channelID?: Uint8Array | null;
  @observable fileName?: string | null;
  @observable scope?: string | null;

  @observable abortController?: AbortController;
  @observable dataFile?: FileData | null;
  @observable isCanceled?: boolean;
  @observable cancelable?: boolean;

  @action fill = (props?: Partial<IAttachmentProgress>) => {
    Object.assign(this, props);
  };
}

export default AttachmentProgress;
